import { render, staticRenderFns } from "./InformationalModal.vue?vue&type=template&id=33ab5be8&"
import script from "./InformationalModal.vue?vue&type=script&lang=js&"
export * from "./InformationalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports